import { API } from '../constants/api';

import { axiosInterceptor } from './interceptors';

interface IAddressBookParams {
    page?: number;
    limit?: number;
    search?: string;
}

export const getAddressList = async (params: IAddressBookParams) => {
    const response = await axiosInterceptor.get(API.ADDRESS_BOOK.GET, { params });

    return response;
};

export const createAddress = async (data: any) => {
    const response = await axiosInterceptor.post(API.ADDRESS_BOOK.CREATE, data);

    return response;
};

export const updateAddress = async (data: any) => {
    const response = await axiosInterceptor.put(API.ADDRESS_BOOK.UPDATE, data);

    return response;
};

export const deleteAddress = async (id: string) => {
    const response = await axiosInterceptor.delete(`${API.ADDRESS_BOOK.DELETE}/${id}`);

    return response;
};

export const deleteSingleAddress = async (id: string) => {
    const response = await axiosInterceptor.delete(`${API.ADDRESS_BOOK.DELETE_SINGLE}/${id}`);

    return response;
};

export const updateSingleAddress = async (data: any) => {
    const response = await axiosInterceptor.put(API.ADDRESS_BOOK.UPDATE_SINGLE, data);

    return response;
};

export const updateAddressTableColumnSettings = async (data: any) => {
    const response = await axiosInterceptor.patch(API.TABLE_COLUMN_SETTINGS.UPDATE, data);

    return response;
};

export const importAddressBook = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axiosInterceptor.post(API.ADDRESS_BOOK.IMPORT, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response;
};

export const downloadAddressBookTemplate = async () => {
    const response = await axiosInterceptor.get(API.ADDRESS_BOOK.IMPORT_TEMPLATE, { responseType: 'blob' });

    // The interceptor unwraps a 200 body, so this is already the blob payload.
    const blob = new Blob([response as any], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Address_Book_Import_Template.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};
